module.exports = __webpack_public_path__ + "img/g2w-brand.f98d22a8.svg";